import { render, staticRenderFns } from "./Territorios.vue?vue&type=template&id=77c7246f&scoped=true&"
import script from "./Territorios.vue?vue&type=script&lang=js&"
export * from "./Territorios.vue?vue&type=script&lang=js&"
import style0 from "./Territorios.vue?vue&type=style&index=0&id=77c7246f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c7246f",
  null
  
)

export default component.exports